import TablePagination from '../component/TablePagination';
import { newestOrderFirst } from '../utils/orderSort';
import React, { useEffect, useRef, useState } from "react";
import Layout from "../component/Layout";
import "./PendingOrders.css";
import { MagnifyingGlassIcon, ShoppingBagIcon, ClockIcon, TruckIcon, ArrowUpTrayIcon, BellAlertIcon, EllipsisVerticalIcon, PencilIcon, TrashIcon, PlusIcon, PrinterIcon } from '@heroicons/react/24/outline';
import { deleteItemcart, deleteOrder, findBusinessByPhoneNumber, getAllPendingOrders, getAllPendingOrdersByBusiness, getAvailableDrivers, getBusinessById, getDrivers, listOrderStatus, updateItemQuantity, updateOrderStatus } from "../adapter/api";
import AsyncStorage from "@react-native-async-storage/async-storage";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import jsPDF from "jspdf";
import "jspdf-autotable";
import { ApiUrlService } from '../api-library/api-services';
import { Client } from '@stomp/stompjs';
import SockJsClient from 'react-stomp'; 
import notification from '../assets/music/notification.mp3';
import { brand as currentBrand, sockJsUrl } from '../config/brands';
import "./OrderModals.css";


const PendingOrders = () => {
  const [orders, setOrders] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const rowsPerPage = 10;
  const [searchTerm, setSearchTerm] = useState("");
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedOrder, setSelectedOrder] = useState(null);
  const [dropdownOpenId, setDropdownOpenId] = useState(null);
  const [isEditModalOpen, setIsEditModalOpen] = useState(false);
  const [currentItem, setCurrentItem] = useState(null);
  const [newQuantity, setNewQuantity] = useState(0);
  const [showConfirmModal, setShowConfirmModal] = useState(false);
  const [showDeleteItemModal, setShowDeleteItemModal] = useState(false);
  const [item, setItem] = useState([]);
  const [userRole, setUserRole] = useState(null);
  const [phoneNumber, setPhoneNumber] = useState(null);
  const [loading, setLoading] = useState(false);
  const [selectedItem, setSelectedItem] = useState(null);
  const [statuses, setStatuses] = useState([])
  const [displayDialog, setDisplayDialog] = useState(false);
  const selectedStatus = selectedOrder?.orderStatus?.name || "";
  const [drivers, setDrivers] = useState()
  const [isConnected, setIsConnected] = useState(false); 
  const SOCKET_URL = sockJsUrl();
  const clientRef = useRef(null);

  const apiUrlService = new ApiUrlService()

  const [isPlaying, setIsPlaying] = useState(false);

  const playSound = () => {
    const audio = new Audio(notification);
    audio.play();
    setIsPlaying(true);

    // Optionally, you can set an event listener for when the sound ends
    audio.onended = () => setIsPlaying(false);
  };

  // Inside the component function
const exportToPDF = () => {
  const doc = new jsPDF();
  
  // Adding title to PDF
  doc.text("Pending Orders", 20, 20);
  
  // Set up headers for the table
  const headers = ["#", "Status", "Date", "Time", "Customer Name", "Customer No.","Driver Name","Driver No."];
  
  // Create rows dynamically based on orders
  const rows = paginatedOrders.map(order => [
    order.orderNumber,
    order.orderStatus?.name,
    formatDate(order.date),
    order.timeCreated,
    order.customerName,
    order.customerPhoneNumber,
    order.driverName,
    order.driverPhoneNumber
  ]);
  
  // Add the table to the PDF
  doc.autoTable({
    head: [headers],
    body: rows,
    startY: 30, // The Y position where the table starts
  });

  // Save the PDF to the local system
  doc.save("pending_orders.pdf");
};

  const handleDeleteClick = (item) => {
    toggleDropdown(null)
    setSelectedItem(item);
    setShowConfirmModal(true);
  };

   

  const confirmDelete = () => {
   
    handleDeleteOrder(selectedItem);
  
  };

  const onMessageReceived = async (msg) => {
    //console.log('New order received:', msg);
     // Transform or validate `msg` if necessary


     const newOrder = {
      orderId: msg.orderId,
      orderNumber: msg.orderNumber,
      orderStatus: msg.orderStatus?.name,
      date: formatDate(msg.date),
      timeCreated: msg.timeCreated,
      business: msg.businessName || "Butler",
      customerName: msg.customerName|| "Unknown",
      customerPhone: msg.customerPhoneNumber || "N/A",
      driverName: msg.driverName || "Not Assigned",
      driverPhone: msg.driverPhoneNumber || "N/A",
    };



 if(userRole === 'ROLE_BUSINESS'  ){
  const response = await findBusinessByPhoneNumber(phoneNumber)
  const response3 = await getBusinessById(msg.business.restaurant_id)
  
  if(response.data.data.name == response3.data.data.name){

    setOrders((prevOrders) => [newOrder, ...prevOrders]); 
    toast.success("New Order")
    playSound()
  }
 }
 else{
  setOrders((prevOrders) => [newOrder, ...prevOrders]); 
  toast.success("New Order")
  playSound()
 }

 if(userRole === 'ROLE_BUSINESS'  ){
  const response2 = await getAllPendingOrdersByBusiness(phoneNumber);
  setOrders(response2.data.data);
}else{
  const response2 = await getAllPendingOrders();
  setOrders(response2.data.data);
}
 
  };


  const handleDeleteOrder = async (order) =>{
    try {

      const response = await deleteOrder(order.orderId);
      if (response.data.status) {

        toast.success("Order Deleted!");
        setShowConfirmModal(false)
        if(userRole === 'ROLE_BUSINESS'  ){
          const response2 = await getAllPendingOrdersByBusiness(phoneNumber);
          setOrders(response2.data.data);
        }else{
          const response2 = await getAllPendingOrders();
          setOrders(response2.data.data);
        }
   
        setOrders(response.data.data);
  
    
      }
    } catch (error) {
      toast.error("Error deleting item!");
      console.error("Delete error:", error);
    }
  }
  const cancelDelete = () => {
    setShowConfirmModal(false);
    setShowDeleteItemModal(false)
  };

  const handleGetStatus = async () => {
    const response = await listOrderStatus();
    statuses.length = 0
    for (var j = 0; j < response.data.data.length; j++) {
        const data = {
            label: response.data.data[j].name,
            value: response.data.data[j].orderStatus_id
        }
        statuses.push(data)
    }
    setStatuses(statuses);
  }

  
  useEffect(() => {
    const fetchUserRole = async () => {
      try {
        const user = await AsyncStorage.getItem("myUser");
        if (user) {
          const parsedUser = JSON.parse(user);
          const { role, email } = parsedUser;
  
          setUserRole(role); // Set the role from AsyncStorage
          setPhoneNumber(email);
  
          setLoading(true);
  
          if (role === 'ROLE_BUSINESS') {
            const response2 = await getAllPendingOrdersByBusiness(email); // Use `email` directly
            setOrders(response2.data.data);
          } else if (role === 'ROLE_ADMIN') {
            const response2 = await getAllPendingOrders();
            setOrders(response2.data.data);
          }
        }
      } catch (error) {
        console.error("Error fetching user role or orders:", error);
      } finally {
        setLoading(false);
      }
    };
  
    fetchUserRole();
  
    // Additional side effects
    handleGetStatus();
    handleGetDrivers();
  }, []); // Dependencies
  
    
 
  


  const handleEditItem = (item) => {
    setCurrentItem(item);
    setNewQuantity(item.quantity);
    setIsEditModalOpen(true);
  };

  const handleSaveQuantity = async (customer) => {

    if (currentItem) {
      currentItem.quantity = newQuantity; // Update the item quantity locally
       
      if(newQuantity != ""){
       
        const response = await updateItemQuantity(selectedOrder.orderId,currentItem.product.productId, newQuantity) 
        
        if(userRole === 'ROLE_BUSINESS'  ){
          const response2 = await getAllPendingOrdersByBusiness(phoneNumber);
          setOrders(response2.data.data);
        }else{
          const response2 = await getAllPendingOrders();
          setOrders(response2.data.data);
        }
        
        toast.success("Quantity edited!")
       

      }
    }
    setIsEditModalOpen(false); // Close the modal after saving
    setIsModalOpen(false)

  };

  const openDriverModal = (order) => {
    toggleDropdown(null)

setSelectedOrder(order)
setDisplayDialog(true)
  }

  const assignToDriver= async (id)=>{


    const bodyObj =
    {
        "driver_Id": id,
    }
    var service = apiUrlService.PutApi(bodyObj)
    fetch(`${currentBrand.apiBaseUrl}/driverOrder/` + selectedOrder.orderId+ '', service).then((response) => response.json())
        .then(async (response) => {
                  const body =
                        {
                            "driverId": id,
                            "orderId": selectedOrder.orderId,
                            "status": null
                        }
                        var service = apiUrlService.PostApi(body)
                        fetch(`${currentBrand.apiBaseUrl}/orderDriver`, service).then((response) => response.json())
                            .then(response => {})
            if (response.status === true) {
              toast.success("Order Assigned!");
  
              if(userRole === 'ROLE_BUSINESS'  ){
                const response2 = await getAllPendingOrdersByBusiness(phoneNumber);
                setOrders(response2.data.data);
              }else{
                const response2 = await getAllPendingOrders();
                setOrders(response2.data.data);
              }
     
              handleGetStatus()
              handleGetDrivers()

            }else{
              toast.error("Choose another driver")
            }
        })
    setDisplayDialog(false); 
  }


    const handleGetDrivers = async () =>{
      const response = await getAvailableDrivers();
      setDrivers(response.data.data)
    }


  const deleteProduct = async () => {
    try {
      const response = await deleteItemcart(item.cartId);
      if (response.data.status) {
        toast.success("Item Deleted!");
        setShowDeleteItemModal(true)
  
        
        };
  
       
    } catch (error) {
      toast.error("Error deleting item!");
      console.error("Delete error:", error);
    }
  };
  

  const handleDeleteItem = async (item) => {

    console.log("Delete item at index:", item);
    setShowDeleteItemModal(true)
    setItem(item)
    
  };


  // Helper Functions
  const formatDate = (date) => new Date(date).toLocaleDateString("en-US", {
    day: "2-digit",
    month: "2-digit",
    year: "numeric",
  });

    // Derived states
    const filteredOrders = orders.filter((order) => {
      const search = searchTerm.toLowerCase();
      return (
        order.orderNumber?.toString().toLowerCase().includes(search) ||
        order.customerName?.toLowerCase().includes(search) ||
        order.customerPhoneNumber?.toLowerCase().includes(search) ||
        order.driverName?.toLowerCase().includes(search) ||
        order.driverPhoneNumber?.toLowerCase().includes(search) ||
        order.orderStatus?.name?.toLowerCase().includes(search) ||
        formatDate(order.date).toLowerCase().includes(search) ||
        order.timeCreated?.toLowerCase().includes(search) || 
        order.businessName?.toLowerCase().includes(search)
      );
    }).sort(newestOrderFirst);
  

  const totalPages = Math.ceil(filteredOrders.length / rowsPerPage);
  useEffect(() => {
    setCurrentPage(page => Math.min(page, Math.max(1, totalPages)));
  }, [totalPages]);
  const paginatedOrders = filteredOrders.slice(
    (currentPage - 1) * rowsPerPage,
    currentPage * rowsPerPage
  );

  const handleEditOrder = async () => {
      setIsModalOpen(false)
      toast.success("Saved!")
  }

  const dropdownRef = useRef(null);
  const buttonRef = useRef(null);




  // Handlers
  const handleSearchChange = (e) => {
    setSearchTerm(e.target.value);
    setCurrentPage(1); // Reset to first page on search
  };
  
  const handlePageChange = (page) => page > 0 && page <= totalPages && setCurrentPage(page);
  const toggleDropdown = (id) => setDropdownOpenId(dropdownOpenId === id ? null : id);
  const openOrderModal = (order) => {
    setSelectedOrder(order);
    setIsModalOpen(true);
  };


  const getStatusClass = (status) => {
    switch (status) {
      case 'Pending':
        return 'bg-customColor text-yellow';
      case 'Cancelled':
        return 'bg-lightRed text-red';
      case 'Confirmed':
        return 'bg-lightBlue text-blue';
      default:
        return 'bg-lightGreen text-green';
    }
  };

  const [selectedImage, setSelectedImage] = useState(null);
  const [isModalImageOpen, setIsModalImageOpen]=  useState(false);

  const handleImageClick = (image) => {
    setSelectedImage(image);
    setIsModalImageOpen(true);
  };

  const closeModalImage = () => {
    setIsModalImageOpen(false);
    setSelectedImage(null);
  };


  const openModal = (order) => {

    toggleDropdown(null)
   
    setSelectedOrder(order); // Set the selected order to display its details
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setIsModalOpen(false);
    setSelectedOrder(null); // Clear selected order when closing the modal
  };


  const changeOrderStatus = async (val) => {

   
    const body =
    {
        "orderStatus": {
            "orderStatus_id": val.value
        }
    }

   const response = await updateOrderStatus(selectedOrder.orderId, val.value )
   if(response.data.status){
    toast.success("Status Updated Successfully!");
    setIsModalOpen(false)

    if(userRole === 'ROLE_BUSINESS'  ){
      const response2 = await getAllPendingOrdersByBusiness(phoneNumber);
      setOrders(response2.data.data);
    }else{
      const response2 = await getAllPendingOrders();
      setOrders(response2.data.data);
    }
    
   

   }





}

const onConnect = async () => {
  console.log('Connected to WebSocket');
  setIsConnected(true);  // Update state when connected
};

const onDisconnect = async () => {
  console.log('Disconnected from WebSocket');
  setIsConnected(false);  // Update state when disconnected
};



  return (
    
    <Layout>
    <div className="po-page">
    <ToastContainer />

    <SockJsClient
        url={SOCKET_URL}
        topics={['/topic/message']}
        onMessage={onMessageReceived}
        onConnect={onConnect}
        onDisconnect={onDisconnect}
        debug={false}
        ref={(client) => {
          clientRef.current = client;
        }}
        onError={(error) => console.error('WebSocket error:', error)}
      />
      <header className="po-header">
        <div><p className="po-eyebrow">{currentBrand.displayName.toUpperCase()} / ORDERS</p><h1>Pending Orders</h1><p>Manage your queue, assign drivers, and keep every delivery on track.</p></div>
        <span className={`po-live ${isConnected ? 'connected' : ''}`}><i />{isConnected ? 'Live updates connected' : 'Live updates disconnected'}</span>
      </header>
      <section className="po-stats" aria-label="Order queue summary">
        {[
          { label: 'Orders in queue', count: orders.length, note: 'All pending orders', Icon: ShoppingBagIcon, tone: 'primary' },
          { label: 'Awaiting a driver', count: orders.filter(order => !order.driverName).length, note: 'Ready for assignment', Icon: ClockIcon, tone: 'orange' },
          { label: 'Driver assigned', count: orders.filter(order => !!order.driverName).length, note: 'Deliveries with a driver', Icon: TruckIcon, tone: 'green' },
        ].map(({ label, count, note, Icon, tone }) => <div className="po-stat" key={label}><div><p>{label}</p><strong>{loading ? '…' : count.toLocaleString()}</strong><small>{note}</small></div><span className={`po-stat-icon ${tone}`}><Icon /></span></div>)}
      </section>
      <section className="po-card" aria-label="Pending order list" aria-busy={loading}>
        <div className="po-toolbar">
          <div className="po-list-title"><h2>Order queue</h2><span>{loading ? '…' : filteredOrders.length}</span></div>
          <div className="po-tools"><label className="po-search"><MagnifyingGlassIcon /><input type="search" value={searchTerm} onChange={handleSearchChange} placeholder="Search orders, customers, drivers…" aria-label="Search pending orders" /></label>
            <button onClick={exportToPDF} disabled={loading || !paginatedOrders.length} className="po-export"><ArrowUpTrayIcon />Export page</button>
          </div>
        </div>
        {loading && <div className="po-loading" role="status">Loading orders…<div /><div /><div /></div>}
        <div className="po-table-scroll overflow-x-auto">
      {/* Orders Table */}
      {!loading &&<table className="data-table min-w-full bg-white border rounded-lg shadow-sm">
        <thead>
          <tr className="bg-grey border-b">
            {["", "#", "Status", "Date", "Time","Store", "Customer Name", "Customer No.","Driver Name","Driver No."].map((header) => (
              <th key={header} className="px-4 py-3 text-left text-sm font-semibold">{header}</th>
            ))}
          </tr>
        </thead>
        <tbody>
          {paginatedOrders.map((order, index) => (
            <tr key={order.orderId} className="hover:bg-gray-50">
              <td className="px-4 py-3 text-yellow cursor-pointer">
                <button type="button" className="po-action" aria-label={`Actions for order ${order.orderNumber}`} aria-expanded={dropdownOpenId === order.orderId} onClick={() => toggleDropdown(order.orderId)}><EllipsisVerticalIcon className="h-5 w-5" /></button>
                {dropdownOpenId === order.orderId && (
                  <div className="po-action-menu">
                     <button className="block w-full text-left px-2 py-1 hover:text-yellow text-gray-700" onClick={()=> openDriverModal(order)}>Assign Order</button>
                    <hr className="w-full border-gray-200 my-2" />
                    <button className="block w-full text-left px-2 py-1 hover:text-yellow text-gray-700" onClick={()=> openModal(order)}>Edit</button>
                    <hr className="w-full border-gray-200 my-2" />
                    <button className="block w-full text-left px-2 py-1 text-red-600 hover:text-yellow text-gray-700" onClick={()=> handleDeleteClick(order)}>Delete</button>
                  </div>
                )}
              </td>
              <td className="px-4 py-3">{order.orderNumber}</td>
              <td className="px-4 py-3">
                <span className={`px-2 py-1 rounded-full ${getStatusClass(order.orderStatus?.name)}`}>
                  {order.orderStatus?.name}
                </span>
              </td>
              <td className="px-4 py-3">{formatDate(order.date)}</td>
              <td className="px-4 py-3">{order.timeCreated}</td>
              <td className="px-4 py-3">{order.businessName ? order.businessName:"Butler"}</td>
              <td className="px-4 py-3">{order.customerName}</td>
              <td className="px-4 py-3">{order.customerPhoneNumber}</td>
              <td className="px-4 py-3 text-sm text-gray-700 font-inter font-medium">
                  {order.driverName || <span className="po-unassigned">Unassigned</span>}
                </td>
                <td className="px-4 py-3 text-sm text-gray-700 font-inter font-medium">
                  {order.driverPhoneNumber}
                </td>
            </tr>
          ))}
        </tbody>
      </table>}
      </div>
      {!loading && !filteredOrders.length && <div className="po-empty"><ShoppingBagIcon /><h3>{searchTerm ? 'No matching orders' : 'Your queue is clear'}</h3><p>{searchTerm ? 'Try a different order number, customer, or driver.' : 'New pending orders will appear here.'}</p>{searchTerm && <button onClick={() => { setSearchTerm(''); setCurrentPage(1); }}>Clear search</button>}</div>}

      {/* Pagination */}
      <div className="po-pagination">
          <span className="text-sm font-medium">
            Showing {filteredOrders.length ? (currentPage - 1) * rowsPerPage + 1 : 0}-{Math.min(currentPage * rowsPerPage, filteredOrders.length)} of{' '}
            {filteredOrders.length}
          </span>
          <TablePagination currentPage={currentPage} totalPages={totalPages} onPageChange={handlePageChange} />
        </div>

      </section>
       {/* Modal */}
  {/* Modal */}
{isModalOpen && selectedOrder && (
  <div className="order-modal-backdrop fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
    <div className="order-modal-panel bg-white max-w-full sm:max-w-2xl md:max-w-3xl w-full rounded-lg shadow-lg p-6 overflow-y-auto max-h-[90vh]">
      <h2 className="text-lg font-semibold mb-4">Order Details</h2>
      <hr className="w-full" style={{ border: "1px solid var(--color-border)", margin: "10px 0" }} />

      {/* Other Order Details */}
      <div>
        <label className="block text-sm font-medium text-gray-700 mb-1">Status</label>
        <select
          className="w-full px-3 py-2 border border-gray-300 rounded-lg mb-4"
          value={selectedStatus}
          onChange={(e) => changeOrderStatus(e.target)} // Handle status change
        >
          {/* Display the selected order's status */}
          <option disabled value={selectedStatus}>
            {selectedStatus}
          </option>
          {/* Render other statuses */}
          {statuses
            .sort((a, b) => a.value - b.value) // Sort by value in ascending order
            .map((status) => (
              <option
                disabled={status.label === selectedStatus}
                key={status.value}
                value={status.value}
              >
                {status.label}
              </option>
            ))}
        </select>

        {selectedOrder.promoCode && selectedOrder.promoCode.code && <label className="block text-sm font-medium text-gray-700 mb-1">Discount</label>}
        {selectedOrder.promoCode && selectedOrder.promoCode.code && <input
          type="text"
          className="w-full px-3 py-2 border border-gray-300 rounded-lg mb-4"
          defaultValue={!selectedOrder.promoCode.cashback ? selectedOrder.promoCode.amount + "%": "- " +selectedOrder.promoCode.amount}$
        />}

        <label className="block text-sm font-medium text-gray-700 mb-1">SubTotal</label>
        <input
          type="text"
          className="w-full px-3 py-2 border border-gray-300 rounded-lg mb-4"
          defaultValue={
            selectedOrder && selectedOrder.totalAmount > 0
            ? ((Number(selectedOrder.totalAmount) - (Number(selectedOrder.deliveryCharge) /90000)) + 0.001).toFixed(2)
            : "0.00"

          }
        />

        
        <label className="block text-sm font-medium text-gray-700 mb-1">Delivery Charge</label>
        <input
          type="text"
          className="w-full px-3 py-2 border border-gray-300 rounded-lg mb-4"
          defaultValue={selectedOrder.deliveryCharge}
        />

        <label className="block text-sm font-medium text-gray-700 mb-1">Total Amount</label>
        <input
          type="text"
          className="w-full px-3 py-2 border border-gray-300 rounded-lg mb-4"
          defaultValue={(selectedOrder.totalAmount).toFixed(2)}
        />
      </div>

      {/* Address Details */}
      {!selectedOrder.pickup ? <div className="mb-4">
        <h4 className="text-md font-semibold mb-2">Address Details</h4>
        {selectedOrder?.address?.street && <p className="text-sm text-gray-700">
          <strong>Street:</strong> {selectedOrder?.address?.street || "N/A"}
        </p>}
        {selectedOrder?.address?.building && <p className="text-sm text-gray-700">
          <strong>Building:</strong> {selectedOrder?.address?.building || "N/A"}
        </p>}
        {selectedOrder?.address?.apartment && <p className="text-sm text-gray-700">
          <strong>Apartment:</strong> {selectedOrder?.address?.apartment || "N/A"}
        </p>}
        {selectedOrder?.address?.instructions && <p className="text-sm text-gray-700">
          <strong>Instructions:</strong> {selectedOrder?.address?.instructions || "N/A"}
        </p>}
        {selectedOrder?.address?.google_map_coordinates && <p className="text-sm text-gray-700">
          <strong>Location:</strong> 
          <a 
            href={`https://www.google.com/maps?q=${selectedOrder?.address?.google_map_coordinates.x},${selectedOrder?.address?.google_map_coordinates.z}`} 
            target="_blank" 
            rel="noopener noreferrer"
            className="text-blue-500 underline"
          >
            View on Google Maps
          </a>
        </p>}
      </div>:<div className="mb-4"> <h4 className="text-md font-semibold mb-2">Address Details</h4><p>Store Pickup</p></div>}

      {/* Address to Details */}
      {selectedOrder.addressTo && <div className="mb-4">
        <h4 className="text-md font-semibold mb-2">To Address Details</h4>
        {selectedOrder?.addressTo?.street && <p className="text-sm text-gray-700">
          <strong>Street:</strong> {selectedOrder?.addressTo?.street || "N/A"}
        </p>}
        {selectedOrder?.addressTo?.building && <p className="text-sm text-gray-700">
          <strong>Building:</strong> {selectedOrder?.addressTo?.building || "N/A"}
        </p>}
        {selectedOrder?.addressTo?.apartment && <p className="text-sm text-gray-700">
          <strong>Apartment:</strong> {selectedOrder?.addressTo?.apartment || "N/A"}
        </p>}
        {selectedOrder?.addressTo?.instructions && <p className="text-sm text-gray-700">
          <strong>Instructions:</strong> {selectedOrder?.addressTo?.instructions || "N/A"}
        </p>}
        {selectedOrder?.addressTo?.google_map_coordinates && <p className="text-sm text-gray-700">
          <strong>Location:</strong> 
          <a 
            href={`https://www.google.com/maps?q=${selectedOrder?.addressTo?.google_map_coordinates.x},${selectedOrder?.addressTo?.google_map_coordinates.z}`} 
            target="_blank" 
            rel="noopener noreferrer"
            className="text-blue-500 underline"
          >
            View on Google Maps
          </a>
        </p>}
      </div>}

      {/* Items List */}
      <div className="mb-4">
        {/* Items Section */}
        <div className="mb-6">
          <h3 className="text-sm font-medium text-gray-700 mb-2">Items</h3>
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
            {selectedOrder.carts.map((item, index) => (
              <div key={index} className="flex items-center rounded-lg p-3">
                <img
                  src={item.product && item.product.image}
                  alt={item.product && item.product.name}
                  onClick={() => handleImageClick(item.product.image)}
                  className="w-16 h-16 rounded-lg object-cover mr-4"
                />
                <div className="flex flex-col flex-grow">
                <div className="text-xs text-gray-600 font-bold"> {item.product.name}</div>
                  <div className="text-xs text-gray-600">Quantity: {item.quantity}</div>
                  <div className="text-xs text-gray-600">
                    {item?.notes?.split('\n').map((line, index) => (
                      <p key={index}>{line}</p>
                    ))}
                  </div>
                  <div className="flex space-x-2 mt-2">
                    <button
                      className="flex border border-darkGrey items-center justify-center w-8 h-8 text-white rounded-lg hover:border-yellow transition"
                      onClick={() => handleEditItem(item)}
                    >
                      <PencilIcon className="w-4 h-4 text-darkGrey hover:text-yellow" />
                    </button>
                    <button
                      className="flex border border-darkGrey items-center justify-center w-8 h-8 text-white rounded-lg hover:border-yellow transition"
                      onClick={() => handleDeleteItem(index)}
                    >
                      <TrashIcon className="w-4 h-4 text-darkGrey hover:text-yellow" />
                    </button>
                  </div>
                </div>
              </div>
            ))}
             {selectedOrder.items.map((item, index) => (
              <div key={index} className="flex items-center rounded-lg p-3">
                <img
                  src={item.image}
                  alt={item.name}
                  onClick={() => handleImageClick(item.image)}
                  className="w-16 h-16 rounded-lg object-cover mr-4"
                />
                <div className="flex flex-col flex-grow">
                <div className="text-xs text-gray-600 font-bold"> {item.name}</div>
                  <div className="text-xs text-gray-600">
                    {item?.notes?.split('\n').map((line, index) => (
                      <p key={index}>{line}</p>
                    ))}
                  </div>
                  <div className="flex space-x-2 mt-2">
                   
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* Promo and Receiver Number */}
      {selectedOrder.promoCode && (
        <div className="flex">
          <label className="block text-sm font-bold text-gray-700 mb-1">PromoCode:</label>
          <label className="block text-sm font-medium text-gray-700 mb-1">
            {selectedOrder.promoCode.code} {selectedOrder.promoCode.amount}%
          </label>
        </div>
      )}

      {selectedOrder.receiverNumber && (
        <div className="flex">
          <label className="block text-sm font-bold text-gray-700 mb-1">Receiver Number:</label>
          <label className="block text-sm font-medium text-gray-700 mb-1">
            {selectedOrder.receiverNumber}
          </label>
        </div>
      )}

      <label className="block text-sm font-bold text-gray-700 mb-1">Notes</label>
      {selectedOrder.leaveWithDoorMan && (
        <label className="block text-sm font-medium text-gray-700 mb-1">Leave With the Door Man</label>
      )}
      {selectedOrder.ringTheBell && (
        <label className="block text-sm font-medium text-gray-700 mb-1">Don't ring the bell</label>
      )}
      {selectedOrder.callMe && (
        <label className="block text-sm font-medium text-gray-700 mb-1">Call when you arrive</label>
      )}
      <textarea
        className="w-full px-3 py-2 border border-gray-300 rounded-lg mb-4"
        rows="3"
        defaultValue={selectedOrder.notes}
      ></textarea>

      {/* Action Buttons */}
      <div className="flex justify-center space-x-2">
        <button
          className="px-5 py-1 bg-white border font-inter border-gray-700 text-gray-700 text-sm rounded-lg hover:bg-yellow hover:text-white hover:border-white"
          onClick={() => handleEditOrder(selectedOrder)}
        >
          SAVE
        </button>
        <button
          className="px-5 py-1 bg-white font-inter border border-gray-700 text-gray-700 text-sm rounded-lg hover:bg-yellow hover:text-white hover:border-white"
          onClick={closeModal}
        >
          CANCEL
        </button>
      </div>
    </div>
  </div>
)}

          {/* Edit Quantity Modal */}
      {isEditModalOpen && currentItem && (
        <div className="order-modal-backdrop fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
          <div className="order-dialog-panel bg-white rounded-lg shadow-lg p-6 w-96">
            <h3 className="text-lg font-semibold mb-4">Edit Quantity</h3>
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">Quantity</label>
              <input
                type="number"
                className="w-full px-3 py-2 border border-gray-300 rounded-lg"
                value={newQuantity}
                onChange={(e) => setNewQuantity(e.target.value)}
              />
            </div>
            <div className="flex justify-end space-x-2 mt-4">
              <button
                className="px-4 py-2 bg-gray-300 rounded-lg"
                onClick={() => setIsEditModalOpen(false)}
              >
                Cancel
              </button>
              <button
                className="px-4 py-2 bg-gray-300 rounded-lg"
                onClick={() => handleSaveQuantity(selectedOrder.customer.customerId)}
              >
                Save
              </button>
            </div>
          </div>
        </div>
      )}

         {/* Confirmation Modal */}
         {showConfirmModal && (
        <div className="order-modal-backdrop fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
          <div className="order-modal-panel order-assign-panel bg-white p-6 rounded-lg shadow-lg">
            <p className="text-lg font-semibold mb-4">
              Are you sure you want to delete this order?
            </p>
            <div className="flex justify-end space-x-4">
              <button
                className="px-4 py-2 bg-gray-400 rounded hover:bg-yellow "
                onClick={cancelDelete}
              >
                No
              </button>
              <button
                className="px-4 py-2 bg-gray-400 rounded hover:bg-yellow"
                onClick={confirmDelete}
              >
                Yes
              </button>
            </div>
          </div>
        </div>
      )}

        {/* Confirmation Modal */}
        {showDeleteItemModal && (
        <div className="order-modal-backdrop fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
          <div className="order-dialog-panel bg-white p-6 rounded-lg shadow-lg">
            <p className="text-lg font-semibold mb-4">
              Are you sure you want to delete this item?
            </p>
            <div className="flex justify-end space-x-4">
              <button
                className="px-4 py-2 bg-gray-400 rounded hover:bg-yellow "
                onClick={cancelDelete}
              >
                No
              </button>
              <button
                className="px-4 py-2 bg-gray-400 rounded hover:bg-yellow"
                onClick={deleteProduct}
              >
                Yes
              </button>
            </div>
          </div>
        </div>
      )}


    {/* Modal for Enlarged Image */}
    {isModalImageOpen && (
        <div className="order-modal-backdrop fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
          <div className="order-dialog-panel bg-white p-6 rounded-lg shadow-lg max-w-3xl">
            <img
              src={selectedImage}
              alt="Enlarged view"
              className="max-w-full max-h-full object-contain"
            />
            <button
              className="absolute top-2 right-2 text-white bg-red-500 rounded-full p-2"
              onClick={closeModalImage}
            >
             Close
            </button>
          </div>
        </div>
      )}


        {/* Driver Modal */}
        {displayDialog && (
        <div className="order-modal-backdrop fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
          <div className="order-modal-panel order-assign-panel bg-white p-6 rounded-lg shadow-lg">
          
            <h2>Assign Order to</h2>
             {drivers.map(x=> 
             <div style={{width:400, marginTop:30}}>
               <button style={{width:400}} 
                className="px-4 py-2 bg-white-400 w-400 rounded hover:bg-yellow "
                onClick={()=> assignToDriver(x.driver_Id)}
              >
                     <p>{x.first_name}</p>
              </button>
         
              <hr />
              </div>
              )}

            <button
                className="px-4 py-2 bg-gray-400 mt-20 rounded hover:bg-yellow"
                onClick={() => setDisplayDialog(false)}
              >
                Cancel
              </button>
             
   
          </div>
        </div>
      )}

         
    </div>
    </Layout>
  );
};

export default PendingOrders;
